export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14385.8adf0611.jpg";